module.exports = __webpack_public_path__ + "static/media/txt.2d64183e.svg";